import createIcon from '../../createIcon';

/**
 * @component @name MicOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTEuNUgxNy4zQzE3LjMgMTIuMjQgMTcuMTQgMTIuOTMgMTYuODcgMTMuNTVMMTguMSAxNC43OEMxOC42NiAxMy44IDE5IDEyLjY5IDE5IDExLjVaTTE0Ljk4IDExLjY3QzE0Ljk4IDExLjYxIDE1IDExLjU2IDE1IDExLjVWNS41QzE1IDMuODQgMTMuNjYgMi41IDEyIDIuNUMxMC4zNCAyLjUgOSAzLjg0IDkgNS41VjUuNjhMMTQuOTggMTEuNjdaTTQuMjcgMy41TDMgNC43N0w5LjAxIDEwLjc4VjExLjVDOS4wMSAxMy4xNiAxMC4zNCAxNC41IDEyIDE0LjVDMTIuMjIgMTQuNSAxMi40NCAxNC40NyAxMi42NSAxNC40MkwxNC4zMSAxNi4wOEMxMy42IDE2LjQxIDEyLjgxIDE2LjYgMTIgMTYuNkM5LjI0IDE2LjYgNi43IDE0LjUgNi43IDExLjVINUM1IDE0LjkxIDcuNzIgMTcuNzMgMTEgMTguMjJWMjEuNUgxM1YxOC4yMkMxMy45MSAxOC4wOSAxNC43NyAxNy43NyAxNS41NCAxNy4zMkwxOS43MyAyMS41TDIxIDIwLjIzTDQuMjcgMy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MicOff = createIcon('MicOff', [
  [
    'path',
    {
      d: 'M19 11.5H17.3C17.3 12.24 17.14 12.93 16.87 13.55L18.1 14.78C18.66 13.8 19 12.69 19 11.5ZM14.98 11.67C14.98 11.61 15 11.56 15 11.5V5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V5.68L14.98 11.67ZM4.27 3.5L3 4.77L9.01 10.78V11.5C9.01 13.16 10.34 14.5 12 14.5C12.22 14.5 12.44 14.47 12.65 14.42L14.31 16.08C13.6 16.41 12.81 16.6 12 16.6C9.24 16.6 6.7 14.5 6.7 11.5H5C5 14.91 7.72 17.73 11 18.22V21.5H13V18.22C13.91 18.09 14.77 17.77 15.54 17.32L19.73 21.5L21 20.23L4.27 3.5Z',
      key: '5pqvyf',
    },
  ],
]);

export default MicOff;
